export const MIN_SCORE = 0
export const MAX_SCORE = 10

export const VARIANT_SQUARE = 'square'
export const VARIANT_NUMBER = 'number'

export const SIZE_SMALL = 'small'
export const SIZE_MEDIUM = 'medium'
export const SIZE_BIG = 'big'
